import React from 'react';
import { AlertCircle, CloudOff, UserRound } from 'lucide-react';
import { htmlSeguro } from '../../../lib/formularios';
import { entrarYVolver } from '../../../lib/dominios';

/*
 * Cabeceras de la página para responder: la del formulario (título, descripción, sesión), la de
 * cada sección a partir de la segunda, la tarjeta del correo y las tarjetas de aviso (cerrado,
 * pide sesión, ya respondiste…), que usan el mismo lienzo para que no parezca otra página.
 */

export function TarjetaEncabezado({ datos, completa = true, hayObligatorias = false }) {
  const sesion = datos.sesion || {};
  const recopilar = datos.ajustes?.recopilar_correos;
  return (
    <div className="fm-tarjeta fm-tarjeta-encabezado fr-encabezado">
      <h1 className="fm-titulo-form">{datos.titulo || 'Formulario sin título'}</h1>
      {completa && datos.descripcion && (
        <div className="fm-descripcion fr-encabezado-descripcion" dangerouslySetInnerHTML={{ __html: htmlSeguro(datos.descripcion) }} />
      )}
      {completa && (sesion.correo || hayObligatorias || recopilar === 'verificados') && (
        <div className="fr-encabezado-pie">
          {sesion.correo && (
            <div className="fr-sesion">
              <UserRound className="h-4 w-4 shrink-0" aria-hidden="true" />
              <strong className="fr-sesion-correo">{sesion.correo}</strong>
              {!datos.vista_previa && (
                <button type="button" className="fm-boton-texto fr-sesion-cambiar" onClick={() => entrarYVolver()}>
                  Cambiar de cuenta
                </button>
              )}
              {recopilar !== 'verificados' && (
                <span className="fr-sesion-nota">
                  <CloudOff className="h-4 w-4" aria-hidden="true" /> No compartido
                </span>
              )}
            </div>
          )}
          {recopilar === 'verificados' && (
            <p className="fr-sesion-aviso">
              Se registrará el correo de tu cuenta cuando envíes este formulario.
            </p>
          )}
          {hayObligatorias && <p className="fm-nota-obligatoria">* Indica que la pregunta es obligatoria</p>}
        </div>
      )}
    </div>
  );
}

export function TarjetaSeccion({ seccion, indice, total }) {
  return (
    <>
      <div className="fm-seccion-rotulo">Sección {indice + 1} de {total}</div>
      <div className="fm-tarjeta fr-seccion">
        <h2 className="fr-seccion-titulo">{seccion.item?.titulo || 'Sección sin título'}</h2>
        {seccion.item?.descripcion && <div className="fm-descripcion">{seccion.item.descripcion}</div>}
      </div>
    </>
  );
}

export function TarjetaCorreo({ correo, onCorreo, error }) {
  return (
    <div className={`fm-tarjeta fr-pregunta ${error ? 'is-error' : ''}`} id="pregunta-__correo__">
      <label className="fm-titulo-pregunta fr-pregunta-titulo" htmlFor="fr-campo-correo">
        Correo electrónico<span className="fm-obligatoria" aria-hidden="true">*</span>
      </label>
      <div className="fr-pregunta-campo">
        <input
          id="fr-campo-correo"
          type="email"
          inputMode="email"
          autoComplete="email"
          className="fm-campo-linea fr-texto-corto"
          placeholder="Tu correo electrónico"
          value={correo}
          onChange={(e) => onCorreo(e.target.value)}
          aria-required="true"
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? 'fr-error-correo' : undefined}
        />
      </div>
      {error && (
        <div className="fm-error-texto" id="fr-error-correo" role="alert">
          <AlertCircle className="h-4 w-4 shrink-0" aria-hidden="true" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}

/** Tarjeta de aviso sobre el lienzo del formulario (cerrado, pide sesión, ya respondiste…). */
export function TarjetaAviso({ titulo, children, acciones }) {
  return (
    <div className="fm-tarjeta fm-tarjeta-encabezado fr-aviso">
      {titulo && <h1 className="fm-titulo-form">{titulo}</h1>}
      <div className="fr-aviso-cuerpo">{children}</div>
      {acciones && <div className="fr-aviso-acciones">{acciones}</div>}
    </div>
  );
}
